import * as ProLogos from "../../../svgs/proLogos";

function ProLogo({ name, ...props }) {
  switch (name) {
    case "channelview":
      return <ProLogos.ChannelViewProLogo {...props} />;
    case "endr":
      return <ProLogos.EndrProLogo {...props} />;
    case "lifehealth":
      return <ProLogos.LifeHealthProLogo {...props} />;
    case "apa":
      return <ProLogos.APAProLogo {...props} />;
    case "nooro":
      return <ProLogos.NooroProLogo {...props} />;
    case "OrchardView":
      return <ProLogos.OrchardViewProLogo {...props} />;
    case "houstoncc":
      return <ProLogos.HoustonCCProLogo {...props} />;
    case "mike":
      return <ProLogos.DailyDoseProLogo {...props} />;
    case "primer":
      return <ProLogos.PrimerProLogo {...props} />;
    case "capella":
      return <ProLogos.CapellaProLogo {...props} />;
    case "asu":
      return <ProLogos.ASUProLogo {...props} />;
    case "azcyber":
      return <ProLogos.AzCyberProLogo {...props} />;
    case "chemonics":
      return <ProLogos.ChemonicsProLogo {...props} />;
    case "verumseminary":
      return <ProLogos.VerumSeminaryProLogo {...props} />;
    case "axio":
      return <ProLogos.AxioProLogo {...props} />;
    case "axiodemo":
      return <ProLogos.AxioDemoProLogo {...props} />;
    case "academica":
      return <ProLogos.AcademicaProLogo {...props} />;
    case "imentor":
      return <ProLogos.IMentorProLogo {...props} />;
    case "cuesta":
      return <ProLogos.CuestaProLogo {...props} />;
    case "jessup":
      return <ProLogos.JessupProLogo {...props} />;
    case "parable":
      return <ProLogos.ParableProLogo {...props} />;
    case "umich":
      return <ProLogos.UMichProLogo {...props} />;
    case "lighthouse":
      return <ProLogos.BelhavenProLogo {...props} />;
    case "gmi":
      return <ProLogos.GMIProLogo {...props} />;
    case "jessuponline":
      return <ProLogos.JessupOnlineProLogo {...props} />;
    case "inspirework":
      return <ProLogos.InspireWorkProLogo {...props} />;
    case "core":
      return <ProLogos.CoreProLogo {...props} />;
    case "pmjessup":
      return <ProLogos.PMJessupProLogo {...props} />;
    default:
      return null;
  }
}

export default ProLogo;
